import React from "react";
import { PrismicRichText } from "@prismicio/react";
import { components } from "../../utils/rt-mods";
import CardNormal from "../slice-components/card-normal";
import Slider from "react-slick";

export const Card = (props) => {
  const sc = props.slice.primary;

  const cards = props.slice.items;

  let space = sc.spacing;

  if (space === "Both large") {
    space = "gutter";
  } else if (space === "Both small") {
    space = "gutter sm";
  } else if (space === "Top large") {
    space = "gutter bot";
  } else if (space === "Top small") {
    space = "gutter bot sm";
  } else if (space === "Bottom large") {
    space = "gutter top";
  } else {
    space = "gutter top sm";
  }

  let boxbg =
    sc.box_background === "gradient"
      ? "gradient-to-b from-grey-light to-white"
      : sc.box_background;

  let bg;
  if (sc.background === "gradient") {
    bg = "gradient-to-b from-grey-light to-white";
  } else if (sc.background === "grey") {
    bg = "grey-light";
  } else {
    bg = sc.background;
  }

  const backgroundColors = ["teal", "purple", "green", "orange", "grey"];

  let boxTextColor = backgroundColors.includes(sc.box_background)
    ? "text-white"
    : "text-grey";

  let isThereBox = sc.box ? "rounded-2xl p-6 md:p-12 bg-" + boxbg : "";

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    className: "upcomin",
    nextArrow: <div><i className="fa-solid fa-chevron-right text-grey text-3xl cursor-pointer" /></div>,
    prevArrow: <div><i className="fa-solid fa-chevron-left text-grey text-3xl cursor-pointer" /></div>,
    touchThreshold:100,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ]
  };


  return (
    <section className={"relative bg-" + bg + " " + space}>
      {sc.section_title.text ? (
        <div className="wrapper">
          <div className="md:text-center md:w-3/4 md:m-auto mb-12 md:mb-12">
            <PrismicRichText field={sc.section_title.richText} />
            {sc.section_content.text ? (
              <PrismicRichText
                field={sc.section_content.richText}
                components={components}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      ) : (
        ""
      )}
      <div
        className={
          "wrapper flex flex-col md:flex-row flex-wrap justify-center gap-8 " +
          (isThereBox ? boxTextColor + " " + isThereBox : "")
        }
      >
        {sc.card_slider === true ?
        <Slider {...settings}>
          {cards.map((card) => {
            return (<CardNormal card={card} sc={sc} slide='slider-card' />)
          })}
        </Slider>  : 
        <>
        {cards.map((card) => {
            return (<CardNormal card={card} sc={sc} />)
          })}
          </>
        }
        
      </div>
    </section>
  );
};
